import VirtualDomElement from '../VirtualDomElement';

interface CircleParams {
  x: number;
  y: number;
  fillColor?: string;
  radius: number;
  strokeColor?: string;
  opacity?: number;
  strokeWidth?: number;
}

export default class Circle extends VirtualDomElement {
  constructor({
    x,
    y,
    radius = 10,
    strokeColor = '#ccc',
    fillColor = null,
    opacity = 1,
    strokeWidth = 1,
  }: CircleParams) {
    super();
    this.set('x', x);
    this.set('y', y);
    this.set('strokeColor', strokeColor);
    this.set('strokeWidth', strokeWidth);
    this.set('fillColor', fillColor);
    this.set('radius', radius);
    this.set('opacity', opacity);
  }

  draw(ctx, transform) {
    const opacityBefore = ctx.globalAlpha;
    ctx.globalAlpha = this.get('opacity') * opacityBefore;

    ctx.strokeStyle = this.get('strokeColor');
    ctx.lineWidth = this.get('strokeWidth') * transform.k;

    ctx.fillStyle = this.get('fillColor');
    const [x, y] = transform.apply([this.get('x'), this.get('y')]);

    if (this.get('strokeColor') !== null) {
      ctx.arc(
        x,
        y,
        (this.get('radius') + this.get('strokeWidth') / 2) * transform.k,
        0,
        2 * Math.PI,
      );
      ctx.stroke();
      ctx.beginPath();
    }
    //ctx.fillRect(x,y,this.get('radius')*transform.k,this.get('radius')*transform.k);
    if (this.get('fillColor') !== null) {
      ctx.arc(x, y, this.get('radius') * transform.k, 0, 2 * Math.PI);
      ctx.fill();
      ctx.beginPath();
    }

    ctx.globalAlpha = opacityBefore;
  }
}
